import { Injectable } from '@nestjs/common';
import * as fs from 'fs';
import * as xlsx from 'xlsx'; // npm install xlsx
import { Repository } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import { CommonResponse,VendorBankColumns,VendorBanksModelDto, VendorBanksResponseModel } from '@gtpl/shared-models/masters';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { vendorBanksEntity } from './vendor-banks.entity';
import { VendorBanksLogEntity } from './vendor-banks-log.entity';


@Injectable()
export class VendorBanksService {
  constructor(
    @InjectRepository(vendorBanksEntity)
    private vendorBankRepository: Repository<vendorBanksEntity>
  ) {}

  async BankNamesuploadExcel(formData: any): Promise<VendorBanksResponseModel> {
    console.log(formData, 'oooooooser');
    const transactionManager = new GenericTransactionManager();
    try {
      await transactionManager.startTransaction();
      const flag = new Set<boolean>();
      const columnArray = [];
      const updatedArray = formData.data.map((obj) => {
        const updatedObj = {};
        for (const key in obj) {
          const newKey = key
            .replace(/\s/g, '')
            .replace(/[\(\)\.]/g, '')
            .replace(/-/g, '');
          if (newKey != '') {
            columnArray.push(newKey);
            updatedObj[newKey] = obj[key];
          }
        }
        return updatedObj;
      });
      const difference = columnArray.filter(
        (element) => !VendorBankColumns.includes(element)
      );
      console.log(difference, '----');
      if (difference.length > 0) {
        await transactionManager.releaseTransaction();
        return new VendorBanksResponseModel(
          false,
          1110,
          "Excel columns doesn't match. Please attach the correct file."
        );
      }
      const convertedData = updatedArray.map((obj) => {
        const updatedObj = {};
        for (const key in obj) {
          const value = obj[key];
          if (value === '') {
            updatedObj[key] = null;
          } else {
            updatedObj[key] = value;
          }
        }
        return updatedObj;
      });
      // const deleteData = await transactionManager.getRepository(vendorBanksEntity).delete({})
      // if (deleteData) {
      //     flag.add(true)
      // } else {
      //     flag.add(false)
      //     return new VendorBanksResponseModel(false, 0, 'Something wwent wrong in data deletion')
      // }
      for (const data of convertedData) {
        // let dtoData
        if (data.BankNames != null) {
          const existedData = await this.vendorBankRepository.findOne({
            where: {
             
              bankName: data.BankNames,
            },
          });
          if (existedData) {
            const update = await transactionManager
              .getRepository(vendorBanksEntity)
              .update({ id: existedData.id }, { bankName: data.BankNames ,updatedUser:existedData.createdUser});
            if (!update.affected) {
              flag.add(false);
              await transactionManager.releaseTransaction();
              return new CommonResponse(
                false,
                0,
                'Something went wrong in updating existing record'
              );
            } else {
              const logs = new VendorBanksLogEntity();
              
              logs.bankName = existedData.bankName;
              logs.vendorBankId = existedData.id;
              const addupdatedData = await transactionManager
                .getRepository(VendorBanksLogEntity)
                .save(logs);
              if (addupdatedData) {
                flag.add(true);
              } else {
                flag.add(false);
                await transactionManager.releaseTransaction();
                break;
              }
            }
          } else {
            const addObj = new vendorBanksEntity();
           addObj.createdUser = formData.user
            addObj.bankName = data.BankNames;
            const addSave = await transactionManager
              .getRepository(vendorBanksEntity)
              .save(addObj);
            if (addSave) {
              flag.add(true);
            } else {
              flag.add(false);
              await transactionManager.releaseTransaction();
              return new VendorBanksResponseModel(false, 0, 'Somthing went wrong in saving the data');
            }
          }
        }
      }
      if (!flag.has(false)) {
        await transactionManager.completeTransaction();
        return new VendorBanksResponseModel(true, 1, 'Data saved successfully');
      } else {
        await transactionManager.releaseTransaction();
        return new VendorBanksResponseModel(false, 0, 'Something went wrong');
      }
    } catch (err) {
      await transactionManager.releaseTransaction();
      return new VendorBanksResponseModel(false, 0, 'Something went wrong');
    }
  }

  async getBankNames(): Promise<VendorBanksResponseModel> {
    try {
        let res = []
      const info = await this.vendorBankRepository.find();
      if (info.length>0) {
        for (const data of info){
            res.push(new VendorBanksModelDto(data.id,data.bankName))
        }
        return new VendorBanksResponseModel(true, 1, 'Data retrieved', info);
      } else {
        return new VendorBanksResponseModel(false, 0, 'No data found');
      }
    } catch (err) {
      return new VendorBanksResponseModel(false, 0, 'Something went wrong', err);
    }
  }
}
